import getUserCountryFromClient from "@/lib/user-context/getUserCountryFromClient";
import { PRODUCT_TYPES } from "../constants";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";
import { getFacetAttributeName } from "./getFacetAttributeName";
import {
  onlyArchivedCourseRunsExclusion,
  type SearchFiltersOptions,
} from "./onlyArchivedCourseRunsFilter";

const getFilters = (options?: SearchFiltersOptions) => {
  const {
    productType,
    indexName: indexNameOverride,
    excludeOnlyArchivedCourseRuns = true,
  } = options ?? {};
  const indexName = indexNameOverride || (PRODUCT_INDEX_EN as string);

  const userCountry = getUserCountryFromClient();
  const productTypeFilter = productType
    ? `product:"${productType}"`
    : PRODUCT_TYPES.map((type) => `product:"${type}"`).join(" OR ");

  // Use centralized field name mapping
  const blockedInField = getFacetAttributeName("blocked_in", { indexName });
  const allowedInField = getFacetAttributeName("allowed_in", { indexName });

  const locationRestrictionFilter = `(${blockedInField}:null OR NOT ${blockedInField}:"${userCountry}") AND (${allowedInField}:null OR ${allowedInField}:"${userCountry}")`;

  const searchVisibilityFilter =
    indexName !== "product"
      ? ` AND showInAlgoliaSearchResults:true${onlyArchivedCourseRunsExclusion(excludeOnlyArchivedCourseRuns)}`
      : "";

  const filterString = `(${productTypeFilter}) AND ${locationRestrictionFilter}${searchVisibilityFilter}`;

  return filterString;
};

export default getFilters;
